import { useTheme } from '@emotion/react';
import { AutocompleteRenderInputParams, TextField } from '@mui/material';

interface RenderInputTextFieldProps {
    readonly params: AutocompleteRenderInputParams;
    readonly disabled?: boolean;
}

function RenderInputTextField({ params, disabled }: RenderInputTextFieldProps) {
    const theme = useTheme();
    return (
        <TextField
            {...params}
            sx={{
                minWidth: '192px',
                color: theme.palette.text.primary,
                bgcolor: theme.palette.background.paper,
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: `${
                        disabled ? theme.palette.border.disabled : theme.palette.border.light
                    } !important`,
                },
                '::placeholder': {
                    color: theme.palette.grey[500],
                },
                borderRadius: '8px',
            }}
        />
    );
}
export default RenderInputTextField;
